import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import Api from '../../lib/seam-api';

class SearchBox extends Component {
    constructor(props) {
        super(props);
    }

    render () {
        return (
            <div className="input-outer">
                <input placeholder="What are you looking for?" value={this.props.search} onChange={this.props.onChangeHandler}/>
            </div>
        )
    }
}


export default SearchBox;